import React from "react"
import styled from "styled-components"

const CloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

const ContentDescription = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #7a7a7a;
  max-width: 431px;
  width: 100%;
`

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000000;
  background-color: rgba(0, 0, 0, 0.6);
  overflow-y: hidden;
`

const Card = styled.div`
  max-width: 900px;
  width: 100%;
  height: 540px;
  color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  display: grid;
  place-items: center;
  overflow-y: scroll;
  @media (max-width: 700px) {
    height: auto;
    width: 90vw;
  }
`

const CardPadding = styled.div`
  /* padding: 29px; */
  /* padding: 0; */
  padding: 20px;
`

const CardContent = styled.div`
  position: relative;
  z-index: 1000000000;
  background: #fcfcfc;
  border-radius: 10px;
  max-width: 900px;
  width: 100%;
  /* height: 540px; */
  height: 100%;
  color: black;
`
const CardWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  margin-bottom: 32px;
  /* @media (max-width: 460px) {
    margin-bottom: 0;
  } */
`

const CustomImage = styled.div`
  background-image: ${props => `url(${props.url})`};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  cursor: ${props => `${props?.cursor ? props.cursor : "pointer"}`};
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 400px;
  @media (max-width: 460px) {
    width: 100%;
    height: 300px;
  }
`

const ContentFlex = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
  flex-direction: row;
  @media (max-width: 1200px) {
    flex-direction: column;
  }
`

const SubTitle = styled.h4`
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #222222;
  margin-bottom: 4px;
`

const ContentTitle = styled.h3`
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  color: #222222;
`

const H3 = styled.h3`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #222222;
  margin-bottom: 8px;
  cursor: pointer;
`

const Space = styled.div`
  height: 20px;
  @media (max-width: 700px) {
    height: 0;
  }
`

const P = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #7a7a7a;
`

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const DetailsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const ModalTitleSpace = styled.div`
  height: 47px;
  @media (max-width: 700px) {
    height: 0px;
  }
`
const ModalContentSpace = styled.div`
  height: 42px;
  @media (max-width: 700px) {
    height: 22px;
  }
`
const ModalDescriptionSpace = styled.div`
  height: 32px;
  @media (max-width: 700px) {
    height: 12px;
  }
`

const ImageWrapper = styled.div`
  /* padding: 40px 20px; */
`

function ModalProduct(props) {
  const [state, setState] = React.useState(false)
  const [product, setProduct] = React.useState(null)
  const openModal = props => {
    setState(true)
    setProduct({ ...props })
  }

  const closeModal = () => {
    setState(false)
    setProduct(null)
  }
  return (
    <>
      {props.data.us.edges.map(item => {
        return (
          <CardWrapper key={item.node.id}>
            <ImageWrapper>
              <CustomImage
                url={item.node.image.url}
                onClick={() => openModal(item)}
              />
            </ImageWrapper>
            <Space />
            <div>
              <TitleWrapper>
                <H3 onClick={() => openModal(item)}>{item.node.image.title}</H3>
                <DetailsWrapper>
                  <span
                    style={{ cursor: "pointer", fontSize: "14px" }}
                    onClick={() => openModal(item)}
                  >
                    {props.title}
                  </span>
                  <span onClick={() => openModal(item)}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ cursor: "pointer" }}
                    >
                      <path
                        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                        fill="white"
                      />
                      <g clipPath="url(#clip0_471_4216)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.46558 12.0001C5.537 12.123 5.63005 12.277 5.74416 12.4537C6.05073 12.9284 6.50469 13.5595 7.0939 14.188C8.28508 15.4586 9.94621 16.6335 11.9999 16.6335C14.0536 16.6335 15.7147 15.4586 16.9059 14.188C17.4951 13.5595 17.949 12.9284 18.2556 12.4537C18.3697 12.277 18.4628 12.123 18.5342 12.0001C18.4628 11.8773 18.3697 11.7233 18.2556 11.5466C17.949 11.0719 17.4951 10.4407 16.9059 9.81222C15.7147 8.54162 14.0536 7.3668 11.9999 7.3668C9.94621 7.3668 8.28508 8.54162 7.0939 9.81222C6.50469 10.4407 6.05073 11.0719 5.74416 11.5466C5.63005 11.7233 5.537 11.8773 5.46558 12.0001ZM19.3332 12.0001C19.9593 11.6871 19.9592 11.6868 19.9591 11.6866L19.958 11.6844L19.9556 11.6798L19.948 11.6648C19.9416 11.6523 19.9325 11.6349 19.9208 11.6128C19.8975 11.5688 19.8637 11.5062 19.8196 11.4278C19.7315 11.271 19.6017 11.0504 19.4317 10.787C19.0924 10.2617 18.588 9.55955 17.9272 8.8547C16.6184 7.45864 14.6129 5.9668 11.9999 5.9668C9.3869 5.9668 7.38136 7.45864 6.07254 8.8547C5.41175 9.55955 4.90737 10.2617 4.56811 10.787C4.39804 11.0504 4.26832 11.271 4.18015 11.4278C4.13604 11.5062 4.10224 11.5688 4.07893 11.6128C4.06726 11.6349 4.05822 11.6523 4.0518 11.6648L4.04415 11.6798L4.04181 11.6844L4.04101 11.686C4.04088 11.6862 4.04045 11.6871 4.66655 12.0001L4.04045 11.6871C3.94192 11.8842 3.94192 12.1161 4.04045 12.3132L4.66655 12.0001C4.04045 12.3132 4.04033 12.3129 4.04045 12.3132L4.04181 12.3159L4.04415 12.3205L4.0518 12.3355C4.05822 12.348 4.06726 12.3654 4.07893 12.3874C4.10224 12.4315 4.13604 12.4941 4.18015 12.5725C4.26832 12.7292 4.39804 12.9499 4.56811 13.2132C4.90737 13.7385 5.41175 14.4407 6.07254 15.1456C7.38136 16.5416 9.3869 18.0335 11.9999 18.0335C14.6129 18.0335 16.6184 16.5416 17.9272 15.1456C18.588 14.4407 19.0924 13.7385 19.4317 13.2132C19.6017 12.9499 19.7315 12.7292 19.8196 12.5725C19.8637 12.4941 19.8975 12.4315 19.9208 12.3874C19.9325 12.3654 19.9416 12.348 19.948 12.3355L19.9556 12.3205L19.958 12.3159L19.9588 12.3143C19.9589 12.314 19.9593 12.3132 19.3332 12.0001ZM19.3332 12.0001L19.9593 12.3132C20.0579 12.1161 20.0576 11.8837 19.9591 11.6866L19.3332 12.0001Z"
                          fill="#525252"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12 10.6998C11.2821 10.6998 10.7 11.2818 10.7 11.9998C10.7 12.7178 11.2821 13.2998 12 13.2998C12.718 13.2998 13.3 12.7178 13.3 11.9998C13.3 11.2818 12.718 10.6998 12 10.6998ZM9.30005 11.9998C9.30005 10.5086 10.5089 9.2998 12 9.2998C13.4912 9.2998 14.7 10.5086 14.7 11.9998C14.7 13.491 13.4912 14.6998 12 14.6998C10.5089 14.6998 9.30005 13.491 9.30005 11.9998Z"
                          fill="#525252"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_471_4216">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(4 4)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </DetailsWrapper>
              </TitleWrapper>
              <P>{item.node.image.description}</P>
            </div>
          </CardWrapper>
        )
      })}

      <div>
        {state && <Overlay onClick={closeModal} />}
        {state === true && product !== null && (
          <Card>
            <CardContent>
              <CardPadding>
                <CloseWrapper>
                  <span onClick={closeModal}>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        // marginTop: "20px",
                        // marginRight: "20px",
                        cursor: "pointer",
                      }}
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14 1.4L12.6 0L7 5.6L1.4 0L0 1.4L5.6 7L0 12.6L1.4 14L7 8.4L12.6 14L14 12.6L8.4 7L14 1.4Z"
                        fill="#222222"
                      />
                    </svg>
                  </span>
                </CloseWrapper>
                <ModalTitleSpace></ModalTitleSpace>
                <ContentFlex>
                  <CustomImage
                    url={product.node.image.url}
                    cursor={"default"}
                  />
                  <div>
                    <ContentTitle>{product.node.image.title}</ContentTitle>
                    <ModalContentSpace></ModalContentSpace>
                    <ContentDescription>
                      {product.node.image.description}
                    </ContentDescription>
                    <ModalDescriptionSpace></ModalDescriptionSpace>
                    <SubTitle>{props.subTitles[0]}</SubTitle>
                    <ContentDescription>
                      {product.node.maintenance}
                    </ContentDescription>
                    <ModalDescriptionSpace></ModalDescriptionSpace>
                    <SubTitle>{props.subTitles[1]}</SubTitle>
                    <ContentDescription>{product.node.size}</ContentDescription>
                    <ModalDescriptionSpace></ModalDescriptionSpace>
                    <SubTitle>{props.subTitles[2]}</SubTitle>
                    <ContentDescription>
                      {product.node.weight}
                    </ContentDescription>
                  </div>
                </ContentFlex>
              </CardPadding>
            </CardContent>
          </Card>
        )}
      </div>
    </>
  )
}

export default ModalProduct
